import type { ExperienceRole } from '../types/content';

export const experienceRoles: ExperienceRole[] = [
  {
    organization: 'LFP Broadcasting LLC',
    location: 'Luxembourg & USA',
    title: 'EVP, Worldwide Business & Member of Executive Management Team',
    period: '02/2023 — Present',
    description:
      'Directs international commercial strategy, worldwide distribution, engineering, and financial planning across 20+ global markets.'
  },
  {
    organization: 'Total Media Solutions',
    location: 'Luxembourg',
    title: 'Founder & Managing Director',
    period: '01/1999 — Present',
    description:
      'International consultancy advising board and C-suite teams on enterprise strategy, international expansion, digital evolution, and high-stakes partnerships.'
  }
];
